// extracted by mini-css-extract-plugin
module.exports = {"item":"_1410bfd27b--item--OE1CK"};